var map = {
	"./icon-accessory-active.png": "6094",
	"./icon-label-active.png": "33a3",
	"./icon-lesson-active.png": "b665",
	"./icon-manuscript-active.png": "666d",
	"./icon-material-active.png": "d3a8",
	"./icon-other-active.png": "5db9",
	"./icon-package-active.png": "00d7",
	"./icon-pattern-active.png": "cecd",
	"./icon-price-active.png": "62a8",
	"./icon-tech-active.png": "7e00",
	"./icon-trademark-active.png": "0481",
	"./icon-xiuhua-active.png": "3139",
	"./icon-yinhua-active.png": "1704"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2669";